import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-4 py-10 space-y-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col space-y-6 items-center\"><div class=\"h-20 w-20 bg-brand-lime text-brand-black rounded-full flex\"><div class=\"m-auto\"><svg class=\"w-7 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\"><path d=\"M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z\"></path></svg></div></div><div class=\"flex flex-col w-full items-center space-y-1\"><div class=\"flex text-white text-2xl font-medium text-center\">Nearby</div><div class=\"text-brand-light-gray text-lg text-center space-y-4\"><p>Within what radius are you looking?</p></div></div></div>", 1)
const _hoisted_3 = { class: "flex flex-col space-y-2 w-full" }

import InputCheckbox from "@/components/InputCheckbox.vue";
import {Ref, ref} from "vue";
import {modalController} from "@ionic/vue";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {usePremium} from "@/composables/usePremium";


export default /*#__PURE__*/_defineComponent({
  __name: 'NearbySheet',
  setup(__props) {

const options = [
  {
    text: 'Within 20 miles',
    value: 20,
  },
  {
    text: 'Within 60 miles',
    value: 60
  },
  {
    text: 'Within 100 miles',
    value: 100
  },
  {
    text: 'Within 200 miles',
    value: 200
  },
  {
    text: 'Within 300 miles',
    value: 300
  },
  {
    text: 'Within 500 miles',
    value: 500,

  }
]

const option: Ref<any[]> = ref([false])

const setOption = async () => {
  const user = await ApiService.User().authUser()
  if (option.value[0] > 20 && !user.subscribed) {
    option.value = [false]
    return await usePremium().presentPayWall({
      text: 'Upgrade to explore further afield.',
      callback: () => {
        //
      }
    })
  }

  return await modalController.dismiss(option.value[0] ?? false)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (o, oIndex) => {
        return _createVNode(InputCheckbox, {
          onClick: setOption,
          key: oIndex,
          name: "option",
          modelValue: option.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((option).value = $event)),
          "return-single-value": true,
          option: o
        }, null, 8, ["modelValue", "option"])
      }), 64))
    ])
  ]))
}
}

})